module.exports = __webpack_public_path__ + "img/slider-image-sm-10.1ad4e007.jpg";